import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import st from './AllOffices.module.css';

type AllOfficesProps = {
  onClick: () => void;
  visible: boolean;
};

const AllOffices: FC<AllOfficesProps> = ({ visible, onClick }) =>
  visible ? (
    <button
      type="button"
      data-testid="allOfficesButton"
      className={st.wrapper}
      onClick={() => onClick()}
    >
      <Link
        to={{
          pathname: '/services/centry-gosudarstvennyh-uslug/',
        }}
        className={st.main}
      >
        Все центры
      </Link>
    </button>
  ) : null;

export default AllOffices;
